import { Input, Select } from 'antd'
import React from 'react';
import get from "lodash/get";
import map from "lodash/map";
import { SearchOutlined } from "@ant-design/icons"

const HeaderSelector = ({ config, searchRef, onSearchTemplate, templates, updateTemplates }) => {
  return (
    <div className='w-full flex justify-end items-center space-x-5 pt-2'>
      <Select size='middle'
        optionFilterProp='label'
        allowSearch
        options={map(get(config, "companies"), (company) => ({ label: get(company, "name"), value: get(company, "id") }))} 
        mode='multiple'
        allowClear
        style={{ minWidth: 250 }}
        value={
          get(templates, "filters.companies")
            ? get(templates, "filters.companies").split(",")
            : []
        }
        placeholder="Select Company"
        onChange={(value) => {
          updateTemplates(get(templates, "filters.page", 1), {
            ...get(templates, "filters"),
            companies: value.length > 0 ? value.join(",") : undefined,
          });
        }}
      />
      <Select size='middle'
        optionFilterProp='label'
        showSearch
        options={map(Object.values(get(config, "template_types.templates", {})), (template) => ({
          label: get(template, "name"),
          value: get(template, "value"),
        }))}
        allowClear
        style={{ minWidth: 250 }}
        placeholder="Select Template Type"
        value={get(templates, "filters.type")}
        onChange={(value) => {
          updateTemplates(get(templates, "filters.page", 1), {
            ...get(templates, "filters"),
            type: value,
          });
        }} />
      <Input size='middle'
        ref={searchRef}
        style={{ width: 250 }}
        onChange={(val) => onSearchTemplate({
          ...get(templates, "filters"),
          query: val.target.value
        })}
        allowClear
        onClear={() => {
          updateTemplates(get(templates, "filters, page"), {
            ...get(templates, "filters"),
            query: undefined,
          })
        }}
        placeholder='Search Template'
        suffix={<SearchOutlined className="mr-2 text-black-3" />} />
    </div>
  )
}

export default HeaderSelector